import React, {useState, forwardRef, useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import {Steps, Button, Modal, message, Tabs} from 'antd';
import CustomerTable from '@/page/customer/InheritPage/CustomerTable';
import UserTable from '@/page/customer/InheritPage/UserTable';
import _ from 'lodash';
import RoomTable from '@/page/customer/RoomPage/RoomTable';

const {TabPane} = Tabs;
const {Step} = Steps;
const StepModal = forwardRef(({user, getResult, transferType = '1'}, ref) => {
    const [visible, setVisible] = useState(false);
    const [current, setCurrent] = useState(0);
    const [disabled, setDisabled] = useState(true);
    const [selectGives, setSelectGives] = useState([]);
    const [selectApplyId, setSelectApplyId] = useState(null);
    const [selectRooms, setSelectRooms] = useState([]);
    const [selectTab, setSelectTab] = useState('1');
    const roomRef = useRef();
    const customerTableRef = useRef();

    const steps =
        transferType === '1'
            ? [
                  {
                      title: '选择客户',
                      content: (
                          <CustomerTable
                              extId={user.extId}
                              selectGive={selectGive}
                              ref={customerTableRef}
                              selectGives={selectGives}
                          />
                      ),
                  },
                  {
                      title: '选择移交员工',
                      content: <UserTable user={user} isComponent={true} select={selectApply} />,
                  },
              ]
            : [
                  {
                      title: '选择客户',
                      content: (
                          <Tabs activeKey={selectTab} onChange={changeTab}>
                              <TabPane tab="客户" key="1">
                                  <CustomerTable
                                      extId={user.extId}
                                      selectGive={selectGive}
                                      selectGives={selectGives}
                                      ref={customerTableRef}
                                  />
                              </TabPane>
                              <TabPane tab="群组" key="2">
                                  <RoomTable
                                      ref={roomRef}
                                      isComponent={true}
                                      owner={user}
                                      selectRooms={selectRoom}
                                      roomKeys={selectRooms}
                                  />
                              </TabPane>
                          </Tabs>
                      ),
                  },
                  {
                      title: '选择移交员工',
                      content: <UserTable user={user} isComponent={true} select={selectApply} />,
                  },
              ];
    useImperativeHandle(ref, () => ({
        open,
    }));

    function changeTab(e) {
        reset();
        !_.isEmpty(customerTableRef.current) && customerTableRef.current.init(true);
        !_.isEmpty(roomRef.current) && roomRef.current.init(true);
        setSelectTab(e);
    }

    function open() {
        setVisible(true);
    }

    function close() {
        reset();
        setVisible(false);
    }

    function reset() {
        setSelectGives([]);
        setSelectApplyId(null);
        setSelectRooms([]);
        setSelectTab('1');
        setDisabled(true);
        setCurrent(0);
    }

    function next() {
        setCurrent(current + 1);
    }

    function prev() {
        setCurrent(current - 1);
    }

    function finish() {
        console.log('fin', selectApplyId, selectGives);
        if (_.isEmpty(selectApplyId)) {
            message.error('未选择员工');
            return;
        }
        getResult(selectApplyId, selectGives);
        reset();
        setVisible(false);
    }

    function selectGive(disabled, selects = []) {
        setDisabled(disabled);
        setSelectGives(selects);
    }

    function selectApply(id) {
        setSelectApplyId(id);
    }

    function selectRoom(flag, roomRowKeys) {
        setDisabled(flag);
        setSelectRooms(roomRowKeys);
    }

    return (
        <Modal
            width={'70%'}
            title={'客户分配'}
            visible={visible}
            footer={null}
            onCancel={close}
            style={{textAlign: 'center'}}
            destroyOnClose={true}
        >
            <div style={{padding: '0px 20px 20px 20px'}}>
                <Steps current={current}>
                    {steps.map(item => (
                        <Step key={item.title} title={item.title} description={item.description} />
                    ))}
                </Steps>
                <p style={{color: 'red', fontSize: 'smaller'}}>
                    注：为保障客户服务体验，90个自然日内，在职成员的每位客户仅可被转接2次。
                </p>
                <div className="steps-content">{steps[current].content}</div>
                <div className="steps-action">
                    {current < steps.length - 1 && (
                        <Button type="primary" onClick={() => next()} disabled={disabled}>
                            下一步
                        </Button>
                    )}
                    {current === steps.length - 1 && (
                        <Button type="primary" onClick={finish}>
                            完成
                        </Button>
                    )}
                    {current > 0 && (
                        <Button style={{margin: '0 8px'}} onClick={() => prev()}>
                            上一步
                        </Button>
                    )}
                </div>
            </div>
        </Modal>
    );
});

StepModal.displayName = 'StepModal';

StepModal.propTypes = {
    user: PropTypes.object.isRequired,
    getResult: PropTypes.func,
    // 1 在职交接 2 离职交接
    transferType: PropTypes.string,
};

export default StepModal;
